<article class="row">
    <section class="col-lg-8 col-md-10 col-sm-12 text-center titulares">
        <h3>Dashboard</h3>
    </section>
</article>
<article class="row">
    <section class="col">
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th>correo</th>
                    <th>nombres</th>
                    <th>apellidos</th>
                    <th>colegio</th>
                    <th>puesto</th>
                    <th>edad</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let participante of participantes; let i = index">
                    <th> {{ i + 1 }} </th>
                    <td>{{ participante.email }} </td>
                    <td>{{ participante.nombres }} </td>
                    <td>{{ participante.apellidos }} </td>
                    <td>{{ participante.colegio }} </td>
                    <td>{{ participante.puesto }} </td>
                    <td>{{ participante.edades }} </td>
                </tr>
            </tbody>
        </table>
    </section>
</article>